import React from "react";
import { useSearchParams } from "react-router-dom";
import BookingFormPage from "./BookingFormPage";
import PackageBooking from "../components/Package/PackageBooking";

const ConsultationRouter = () => {
  const [searchParams] = useSearchParams();

  const subscription = searchParams.get("subscription");
  const plan = searchParams.get("plan");

  // If both parameters exist → show form
  if (subscription && plan) {
    return <BookingFormPage />;
  }

  // Otherwise show package/program screen
  return <PackageBooking />;
};

export default ConsultationRouter;